import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
  scrollTo?: string;
  href?: string;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  scrollTo,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.location.href = href;
      return;
    }
    if (scrollTo) {
      const target = document.getElementById(scrollTo);
      if (target) {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - window.innerHeight / 2 + target.offsetHeight / 2;
        const startPosition = window.scrollY;
        const distance = targetPosition - startPosition;
        const duration = 1800;
        let startTime: number | null = null;
        const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        const animation = (currentTime: number) => {
          if (startTime === null) startTime = currentTime;
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const ease = easeInOutCubic(progress);
          window.scrollTo(0, startPosition + distance * ease);
          if (progress < 1) {
            requestAnimationFrame(animation);
          }
        };
        requestAnimationFrame(animation);
      }
    }
    onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        bg-forest text-white font-medium text-lg px-8 py-4 rounded-full 
        shadow-lg hover:bg-forest-dark transition-colors duration-200
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} onClick={handleClick} {...props} data-id="element-230">
      {children}
    </motion.button>;
}